import { render, staticRenderFns } from "./doubleweight.vue?vue&type=template&id=21b6cab6&scoped=true&"
import script from "./doubleweight.vue?vue&type=script&lang=js&"
export * from "./doubleweight.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=21b6cab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6cab6",
  null
  
)

export default component.exports